const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  addboost: 'e904',
  addmember_filled: 'e905',
  adduser: 'e906',
  add_chat: 'e907',
  add_reaction: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  archive_filled: 'e913',
  arrowcircle: 'e914',
  arrowhead: 'e915',
  arrow_down: 'e916',
  arrow_next: 'e917',
  arrow_prev: 'e918',
  arrow_up_circle_fill: 'e919',
  attach: 'e91a',
  attach_edit: 'e91b',
  audio_repeat: 'e91c',
  audio_repeat_single: 'e91d',
  author_hidden: 'e91e',
  auto_delete_circle_1: 'e91f',
  auto_delete_circle_2: 'e920',
  auto_delete_circle_3: 'e921',
  auto_delete_circle_4: 'e922',
  auto_delete_circle_5: 'e923',
  auto_delete_circle_6: 'e924',
  auto_delete_circle_clock: 'e925',
  auto_delete_circle_days: 'e926',
  auto_delete_circle_empty: 'e927',
  auto_delete_circle_months: 'e928',
  auto_delete_circle_off: 'e929',
  auto_delete_circle_weeks: 'e92a',
  auto_delete_circle_years: 'e92b',
  avatarnext: 'e92c',
  avatarprevious: 'e92d',
  aversion: 'e92e',
  back: 'e92f',
  backward_5: 'e930',
  binfilled: 'e931',
  bold: 'e932',
  bomb: 'e933',
  boost: 'e934',
  boostcircle: 'e935',
  boosts: 'e936',
  botcom: 'e937',
  bots: 'e938',
  bot_filled: 'e939',
  brightness: 'e93a',
  brush: 'e93b',
  bubblereply: 'e93c',
  bug: 'e93d',
  calendar: 'e93e',
  calendarfilter: 'e93f',
  camera: 'e940',
  cameraadd: 'e941',
  captiondown: 'e942',
  captionup: 'e943',
  car: 'e944',
  card: 'e945',
  card_outline: 'e946',
  cash_circle: 'e947',
  channel: 'e948',
  channelviews: 'e949',
  channel_filled: 'e94a',
  chatspinned: 'e94b',
  chatsplaceholder: 'e94c',
  check1: 'e94d',
  checkbox: 'e94e',
  checkboxblock: 'e94f',
  checkboxempty: 'e950',
  checkboxon: 'e951',
  checklist_add: 'e952',
  checklist_done: 'e953',
  checklist_undone: 'e954',
  checkretract: 'e955',
  checkround: 'e956',
  checkround_filled: 'e957',
  clipboard: 'e958',
  clock: 'e959',
  close: 'e95a',
  clouddownload: 'e95b',
  collapse: 'e95c',
  colorize: 'e95d',
  comments: 'e95e',
  commentssticker: 'e95f',
  contrast: 'e960',
  copy: 'e961',
  crop: 'e962',
  cross: 'e963',
  crossgif: 'e964',
  crossround: 'e965',
  crossround_filled: 'e966',
  crossstar: 'e967',
  crown: 'e968',
  crownalt: 'e969',
  crownoff: 'e96a',
  crownoff_outline: 'e96b',
  crown_outline: 'e96c',
  darkmode: 'e96d',
  data: 'e96e',
  delete: 'e96f',
  deletedaccount: 'e970',
  deleteleft: 'e971',
  deleteuser: 'e972',
  delete_filled: 'e973',
  devices: 'e974',
  document: 'e975',
  dollar_circle: 'e976',
  dollar_circle_x: 'e977',
  down: 'e978',
  download: 'e979',
  down_crossed: 'e97a',
  down_up: 'e97b',
  dragfiles: 'e97c',
  dragmedia: 'e97d',
  eats: 'e97e',
  edit: 'e97f',
  email: 'e980',
  endcall_filled: 'e981',
  enhance: 'e982',
  enter: 'e983',
  equalizer: 'e984',
  expand: 'e985',
  eye: 'e986',
  eye1: 'e987',
  eye2: 'e988',
  eyecross_outline: 'e989',
  faceid: 'e98a',
  factcheck: 'e98b',
  fade: 'e98c',
  fast_forward: 'e98d',
  fast_rewind: 'e98e',
  favourites: 'e98f',
  filter: 'e990',
  fire: 'e991',
  flag: 'e992',
  flip: 'e993',
  flip_image_horizontal: 'e994',
  folder: 'e995',
  fontframe: 'e996',
  fontframe_bg: 'e997',
  fontframe_outline: 'e998',
  fontsize: 'e999',
  forward: 'e99a',
  forward_25: 'e99b',
  forward_filled: 'e99c',
  free_transform: 'e99d',
  fullscreen: 'e99e',
  gc_microphone: 'e99f',
  gc_microphoneoff: 'e9a0',
  gem: 'e9a1',
  gem_exchange: 'e9a2',
  gem_transfer: 'e9a3',
  gem_transfer_outline: 'e9a4',
  geometric_digit_0: 'e9a5',
  geometric_digit_1: 'e9a6',
  geometric_digit_2: 'e9a7',
  geometric_digit_3: 'e9a8',
  geometric_digit_4: 'e9a9',
  geometric_digit_5: 'e9aa',
  geometric_digit_6: 'e9ab',
  geometric_digit_7: 'e9ac',
  geometric_digit_8: 'e9ad',
  geometric_digit_9: 'e9ae',
  geometric_dot: 'e9af',
  geometric_letter_x: 'e9b0',
  gifs: 'e9b1',
  gift: 'e9b2',
  gift_premium: 'e9b3',
  grain: 'e9b4',
  group: 'e9b5',
  groupmedia: 'e9b6',
  groupmediaoff: 'e9b7',
  group_filled: 'e9b8',
  group_star: 'e9b9',
  hand: 'e9ba',
  help: 'e9bb',
  hide: 'e9bc',
  highlights: 'e9bd',
  hourglass: 'e9be',
  image: 'e9bf',
  image_original: 'e9c0',
  info: 'e9c1',
  info2: 'e9c2',
  italic: 'e9c3',
  key: 'e9c4',
  keyboard: 'e9c5',
  lamp: 'e9c6',
  language: 'e9c7',
  largepause: 'e9c8',
  largeplay: 'e9c9',
  left: 'e9ca',
  limit_chat: 'e9cb',
  limit_chats: 'e9cc',
  limit_file: 'e9cd',
  limit_folders: 'e9ce',
  limit_link: 'e9cf',
  limit_pin: 'e9d0',
  link: 'e9d1',
  link_paid: 'e9d2',
  list: 'e9d3',
  listscreenshare: 'e9d4',
  livelocation: 'e9d5',
  location: 'e9d6',
  lock: 'e9d7',
  lockoff: 'e9d8',
  loginlogodesktop: 'e9d9',
  loginlogomobile: 'e9da',
  logout: 'e9db',
  mac_command_key: 'e9dc',
  mediaspeed_empty: 'e9dd',
  mediaspoiler: 'e9de',
  mediaspoileroff: 'e9df',
  mention: 'e9e0',
  menu: 'e9e1',
  menu_feature_cover: 'e9e2',
  menu_feature_unique: 'e9e3',
  menu_verification: 'e9e4',
  message: 'e9e5',
  messageunread: 'e9e6',
  message_jump: 'e9e7',
  message_quote: 'e9e8',
  microphone: 'e9e9',
  microphone_crossed: 'e9ea',
  microphone_crossed_filled: 'e9eb',
  microphone_filled: 'e9ec',
  minus: 'e9ed',
  monospace: 'e9ee',
  more: 'e9ef',
  movetochats: 'e9f0',
  movetomenu: 'e9f1',
  multistories: 'e9f2',
  music: 'e9f3',
  mute: 'e9f4',
  muted: 'e9f5',
  mynotes: 'e9f6',
  newchannel: 'e9f7',
  newchannel_filled: 'e9f8',
  newchat_filled: 'e9f9',
  newgroup: 'e9fa',
  newgroup_filled: 'e9fb',
  newprivate: 'e9fc',
  newprivate_filled: 'e9fd',
  newtab: 'e9fe',
  next: 'e9ff',
  nochannel: 'ea00',
  noncontacts: 'ea01',
  nosound: 'ea02',
  note: 'ea03',
  okay: 'ea04',
  online: 'ea05',
  passwordoff: 'ea06',
  pause: 'ea07',
  permissions: 'ea08',
  person: 'ea09',
  phone: 'ea0a',
  phone_filled: 'ea0b',
  pin: 'ea0c',
  pin2: 'ea0d',
  pinlist: 'ea0e',
  pinnedchat: 'ea0f',
  pinned_filled: 'ea10',
  pip: 'ea11',
  play: 'ea12',
  playback_05: 'ea13',
  playback_15: 'ea14',
  playback_1x: 'ea15',
  playback_2x: 'ea16',
  plus: 'ea17',
  plusround: 'ea18',
  poll: 'ea19',
  premium_addone: 'ea1a',
  premium_avatars: 'ea1b',
  premium_badge: 'ea1c',
  premium_colors: 'ea1d',
  premium_double: 'ea1e',
  premium_emoji: 'ea1f',
  premium_filesize: 'ea20',
  premium_lastseen: 'ea21',
  premium_limits: 'ea22',
  premium_lock: 'ea23',
  premium_management: 'ea24',
  premium_noads: 'ea25',
  premium_privacy: 'ea26',
  premium_reactions: 'ea27',
  premium_restrict: 'ea28',
  premium_speed: 'ea29',
  premium_status: 'ea2a',
  premium_stickers: 'ea2b',
  premium_tags: 'ea2c',
  premium_transcription: 'ea2d',
  premium_translate: 'ea2e',
  premium_unlock: 'ea2f',
  premium_wallpaper: 'ea30',
  previous: 'ea31',
  promote: 'ea32',
  quote: 'ea33',
  quote_outline: 'ea34',
  radiooff: 'ea35',
  radioon: 'ea36',
  reactions: 'ea37',
  reactions_filled: 'ea38',
  readchats: 'ea39',
  recent: 'ea3a',
  redo: 'ea3b',
  reload_star: 'ea3c',
  replace: 'ea3d',
  reply: 'ea3e',
  reply_filled: 'ea3f',
  restrict: 'ea40',
  revenue: 'ea41',
  rightpanel: 'ea42',
  rotate: 'ea43',
  rotate_left: 'ea44',
  rotate_right: 'ea45',
  round_chats_filled: 'ea46',
  saturation: 'ea47',
  saved: 'ea48',
  savedmessages: 'ea49',
  schedule: 'ea4a',
  scheduled: 'ea4b',
  screen_crossed: 'ea4c',
  search: 'ea4d',
  select: 'ea4e',
  send: 'ea4f',
  send2: 'ea50',
  sending: 'ea51',
  sendingerror: 'ea52',
  settings: 'ea53',
  settings_clipped_corner: 'ea54',
  settings_filled: 'ea55',
  shadows: 'ea56',
  sharescreen_filled: 'ea57',
  sharingoff: 'ea58',
  sharingoff_filled: 'ea59',
  sharingon: 'ea5a',
  sharpen: 'ea5b',
  shipping: 'ea5c',
  shuffle: 'ea5d',
  smallscreen: 'ea5e',
  smile: 'ea5f',
  sort_date: 'ea60',
  sort_num: 'ea61',
  sort_price: 'ea62',
  speaker: 'ea63',
  speakerfilled: 'ea64',
  speakeroff: 'ea65',
  speakerofffilled: 'ea66',
  spoiler: 'ea67',
  sport: 'ea68',
  star: 'ea69',
  star_filled: 'ea6a',
  statistics: 'ea6b',
  stickers: 'ea6c',
  stickers_face: 'ea6d',
  stop: 'ea6e',
  stories: 'ea6f',
  story: 'ea70',
  storyreply: 'ea71',
  storyrepost: 'ea72',
  strikethrough: 'ea73',
  suggested: 'ea74',
  tag: 'ea75',
  tag_add: 'ea76',
  tag_alt: 'ea77',
  tag_alt_crossed: 'ea78',
  tag_alt_outline: 'ea79',
  tag_crossed: 'ea7a',
  tag_filter: 'ea7b',
  tag_name: 'ea7c',
  text: 'ea7d',
  textedit: 'ea7e',
  timer: 'ea7f',
  time_lock: 'ea80',
  tip: 'ea81',
  ton: 'ea82',
  tools: 'ea83',
  topics: 'ea84',
  trade: 'ea85',
  transcribe: 'ea86',
  unarchive: 'ea87',
  unclaimed: 'ea88',
  underline: 'ea89',
  undo: 'ea8a',
  unmute: 'ea8b',
  unpack: 'ea8c',
  unpin: 'ea8d',
  unread: 'ea8e',
  up: 'ea8f',
  up_down: 'ea90',
  user: 'ea91',
  username: 'ea92',
  videocamera: 'ea93',
  videocamera_crossed_filled: 'ea94',
  videocamera_filled: 'ea95',
  videochat: 'ea96',
  vignette: 'ea97',
  volume_down: 'ea98',
  volume_mute: 'ea99',
  volume_off: 'ea9a',
  volume_up: 'ea9b',
  warmth: 'ea9c',
  warning: 'ea9d',
  webview: 'ea9e',
  win_key: 'ea9f',
  zoomin: 'eaa0',
  zoomout: 'eaa1'
};

export default Icons;
